import { ArrowDownTrayIcon, ArrowPathIcon, ChevronDownIcon, MinusIcon } from "@heroicons/react/20/solid"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Actions as BAMBOOACTIONS } from './store/bambooActions'

import { Cog8ToothIcon } from "@heroicons/react/20/solid"
import { format } from "date-fns"
import { NotificationManager } from "react-notifications"
import Tooltip from "@/tooltip"
import { Actions as ALLOWANCE_ACTIONS } from "../../../store/actions/allowanceActions"
import Logo from "./assets/bamboo-icon.svg"
import BambooFieldSettings from "./BambooFieldSettings"
// const unfinished = true
const unfinished = false

const BambooSettings = ({
  connected,
  needsVerification,
  connect,
  disconnect,
  settings,
  buddyFields,
  getBambooSettings,
  resyncEmployees,
  resyncingEmployees,
  jurisdiction,
  disabled,
  saving,
  saveBambooSettings,
  allowanceGetList,
  importDepartments,
  departmentList,
  lastSyncDate
}) => {


  const [credentials, setCredentials] = useState()
  const [expand, setExpand] = useState(false)
  const [bambooSettings, setBambooSettings] = useState()
  const [bambooOptions, setBambooOptions] = useState()
  const updateSetting = ({ category, field, value }) => {
    setBambooSettings({
      ...bambooSettings,
      [category]: {
        ...bambooSettings?.[category],
        [field]: value
      }
    })
  }
  const updateOptions = ({ field, option, selectedOption }) => {
    setBambooOptions({
      ...bambooOptions,
      [field]: {
        ...bambooOptions?.[field],
        [option]: selectedOption
      }
    })
  }

  useEffect(() => {
    if (!connected) return
    setBambooSettings({ ...settings?.mappedFields })
    setBambooOptions({ ...settings?.mappedOptions })
  }, [settings])

  useEffect(() => {
    if (!connected) {
      setExpand(false)
      return
    }
    if (!expand || !connected) return
    getBambooSettings()
    allowanceGetList()
  }, [connected, expand])

  if (credentials && !connected) return (
    <div className="col-xs-12 integration-row">
      <div className="col-xs-3">
        <img src={Logo} width="40px" />
        <span style={{ paddingLeft: 20, fontSize: 16 }}>Bamboo HR</span>
      </div>
      <div className="col-xs-9">
        <button className="btn btn-primary pull-right" style={{ marginTop: 2 }} onClick={() => {
          if (!credentials.API_KEY || !credentials.subdomain) NotificationManager.error('API Key & Subdomain are required to Connect', 'Connecting Bamboo HR')
          else connect(credentials)
        }}>
          Connect
        </button>
        <div className="col-xs-3 pull-right">
          <div className="form-material">
            <input
              className="form-control"
              id='BAMBOO-HR-API_KEY'
              onChange={(e) => {
                setCredentials({
                  ...credentials,
                  API_KEY: e.target.value
                })
              }}
              autoComplete="off"
            />
            <label htmlFor="BAMBOO-HR-API_KEY">API Key</label>
          </div>
        </div>
        <div className="col-xs-3 pull-right">
          <div className="form-material">
            <input
              className="form-control"
              autoComplete="off"
              htmlFor="BAMBOO-HR-SUB_DOMAIN"
              onChange={(e) => {
                setCredentials({
                  ...credentials,
                  subdomain: e.target.value
                })
              }}
            />
            <label htmlFor="BAMBOO-HR-SUB_DOMAIN">Subdomain</label>
          </div>
        </div>
      </div>
    </div >
  )

  return (
    <div className={`${expand ? "tr-gray" : ""} col-xs-12 integration-row`}>
      <div className="col-xs-6">
        <img src={Logo} width="40px" />
        <span style={{ paddingLeft: 20, fontSize: 16 }}>Bamboo HR </span>
      </div>
      <div className="col-xs-6">
        {unfinished && !connected ?
          <div className="btn btn-default pull-right">
            Coming Soon
          </div>
          :
          <>
            <button className={`btn btn-${connected ? 'default' : 'primary'} pull-right`} style={{ marginTop: 2 }} onClick={() => {
              if (connected) setExpand(!expand)
              else if (!credentials && !connected) setCredentials({})
              else connect()
            }}>
              {connected ?
                <>
                  <Cog8ToothIcon style={{ height: "1.5em", float: "left" }} />
                  <div style={{ float: "left", marginLeft: 5 }}>Settings</div>
                  <ChevronDownIcon
                    style={{
                      height: "1.5em",
                      float: "left",
                      transform: expand ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease-in-out",
                    }} />
                </>
                :
                'Connect'
              }
            </button>
            {connected &&
              <button
                className={`btn ${needsVerification ? 'btn-primary' : 'btn-default'} pull-right`}
                style={{ marginTop: 2, marginRight: 10 }}
              >
                Connected
              </button>
            }
          </>
        }

      </div>
      <div className="clearfix" />
      {expand ?
        <>
          <div className="row" style={{ paddingBottom: 0, paddingTop: '1rem' }}>
            {lastSyncDate ? <div className="col-xs-12">Last Synced: <strong>{format(new Date(lastSyncDate), 'do MMMM, yyyy - HH:mm')}</strong></div> : null}
            <button
              type="button"
              className="btn btn-primary pull-right"
              onClick={() => {
                disconnect()
              }}
            >
              <MinusIcon style={{ height: "1.5em", float: "left" }} />
              <div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
            </button>
            <button
              type="button"
              style={{ marginRight: '1rem' }}
              disabled={resyncingEmployees}
              className="btn btn-default pull-right"
              onClick={() => {
                resyncEmployees()
              }}
            >
              <ArrowPathIcon style={{ height: "1.5em", float: "left" }} className={`${resyncingEmployees ? 'animate-spin' : ''}`} />
              <div style={{ float: "left", marginLeft: 5 }}>Resync{resyncingEmployees ? 'ing...' : null}</div>
            </button>
            {departmentList?.length > 0 ?
              <div
                type="button"
                style={{ marginRight: '1rem' }}
                disabled={!settings?.mappedFields?.['Role Details']?.department}
                className="btn btn-default pull-right"
                onClick={() => {
                  importDepartments()
                }}
              >
                <Tooltip content={'Please Map Your Department Field under Role Details to Import Departments'} isOpen={!settings?.mappedFields?.['Role Details']?.department ? undefined : false}>
                  <ArrowDownTrayIcon style={{ height: "1.5em", float: "left" }} />
                  <div style={{ float: "left", marginLeft: 5 }}>Import Departments</div>
                </Tooltip>
              </div>
              : null}
            {/* <button
              type="button"
              className="btn btn-default pull-right"
              onClick={() => {
                disconnect()
              }}
            >
              <MinusIcon style={{ height: "1.5em", float: "left" }} />
              <div style={{ float: "left", marginLeft: 5 }}>Import Employees</div>
            </button> */}
          </div>
          <BambooFieldSettings 
            category={{ name: 'Leave Types'}}
            disabled={disabled}
            settings={bambooSettings}
            leave={true}
            options={bambooOptions}
            invert={true}
            updateSetting={({ field, value }) => {
              updateSetting({ category: 'Leave Types', field, value })
            }}
            updateOptions={({ option, selectedOption }) => {
              updateOptions({ field: 'Leave Types', option, selectedOption })
            }}
          />
          {buddyFields?.map(item => {
            return (
              <BambooFieldSettings
                category={item}
                disabled={disabled}
                settings={bambooSettings}
                options={bambooOptions}
                updateSetting={({ field, value }) => {
                  updateSetting({ category: item.name, field, value })
                }}
                updateOptions={({ field, option, selectedOption }) => {
                  updateOptions({ field, option, selectedOption })
                }}
              />
            )
          })}
          <div className="row" style={{ paddingBottom: 0, paddingTop: '1rem' }}>
            {buddyFields?.length > 0 ?
              <button
                className="btn btn-success pull-right"
                disabled={saving}
                onClick={() => {
                  saveBambooSettings({
                    mappedFields: bambooSettings,
                    mappedOptions: bambooOptions
                  })
                }}
              >
                {saving ? "Saving..." : "Save"}
              </button>
              : null}
          </div>
        </>
        : null}
      <div className="clearfix" />
    </div >
  )
}

const mapStateToProps = (state) => {
  const { bambooHr } = { ...state.integration?.hris }
  const { options, settings, resyncingEmployees } = { ...state.integration?.hris?.bambooHr }
  const { buddyFields } = { ...options }
  const departmentField = bambooHr?.settings?.mappedFields?.['Role Details']?.department
  const existingDepartments = state.company?.settings?.departments?.map(item => item.bambooReference)
  const departmentList = bambooHr?.options?.bambooFields?.find(item => item.id == departmentField)?.subOptions?.filter(item => !existingDepartments?.includes(item.name))
  return {
    departmentList,
    lastSyncDate: state.integration?.hris?.bambooHr?.lastSyncDate,
    connected: !!bambooHr,
    saving: bambooHr?.savingSettings,
    settings,
    buddyFields,
    resyncingEmployees,
    jurisdiction: state.company?.settings?.jurisdiction
  }
}

const mapDispatchToProps = (dispatch) => ({
  importDepartments: () => dispatch(BAMBOOACTIONS.importDepartmentsModal(true)),
  connect: (credentials) => dispatch(BAMBOOACTIONS.connectBamboo(credentials)),
  disconnect: () => dispatch(BAMBOOACTIONS.disconnectBamboo()),
  getBambooSettings: () => dispatch(BAMBOOACTIONS.getBambooSettings()),
  resyncEmployees: () => dispatch(BAMBOOACTIONS.resyncEmployees()),
  saveBambooSettings: (body) => dispatch(BAMBOOACTIONS.saveBambooSettings(body)),
  allowanceGetList: () => dispatch(ALLOWANCE_ACTIONS.allowanceGetList())
})

export default connect(mapStateToProps, mapDispatchToProps)(BambooSettings)
